import { forwardRef, useId } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Field } from './Field';
import { cn, inputClasses } from './utils';

export interface TextareaProps extends ComponentPropsWithoutRef<'textarea'> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  containerClassName?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { id, label, hint, error, required, className, containerClassName, rows = 4, ...props },
  ref,
) {
  const generatedId = useId();
  const textareaId = id ?? generatedId;

  return (
    <Field
      id={textareaId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={containerClassName}
    >
      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        required={required}
        aria-invalid={error ? true : undefined}
        className={cn(
          inputClasses,
          'min-h-[5rem] resize-y',
          error && 'border-red-500 focus-visible:ring-red-500',
          className,
        )}
        {...props}
      />
    </Field>
  );
});
